import { useMemo } from 'react';
import MUIDataTable from 'mui-datatables';
import { Box, ThemeProvider } from '@mui/material';

import { FBoxContainer } from '../../base';
import {
  getSingleClientsViewColumns,
  singleClientsViewOptions,
  supervisionMetricsTableTheme,
} from './config';

interface SingleClientViewProps {
  id: number;
  dateList: { startDate: string; endDate: string }[];
  period: string;
}

function SingleClientView({ id, dateList, period }: SingleClientViewProps) {
  const data = useMemo(() => {
    return dateList.map((dates) => {
      const { startDate, endDate } = dates;
      return {
        id,
        startDate,
        endDate,
        period,
      };
    });
  }, [dateList]);
  return (
    <FBoxContainer sx={{ boxShadow: 'none', flexGrow: 0 }}>
      <Box>
        <ThemeProvider theme={supervisionMetricsTableTheme}>
          <MUIDataTable
            title=""
            data={data}
            columns={getSingleClientsViewColumns(period)}
            options={singleClientsViewOptions}
          />
        </ThemeProvider>
      </Box>
    </FBoxContainer>
  );
}

export default SingleClientView;
